import './style.scss'

export default function Chart(){
    return(
        <div className={'chart-layout'}>
            <iframe src={'https://chart.finomate.io/'} allowFullScreen={true} className={'w-full'}/>
        </div>
    )
}